// extracted by mini-css-extract-plugin
export default {"loader":"loader_loader__HfRpJ","load8":"loader_load8__+fRoB"};